import React, { Component } from "react"
import PropTypes from "prop-types"
import { BrowserRouter as Router, Switch } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/"
import AppRoute from "./routes/route"

// layouts
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import { requestFirebaseNotificationPermission } from "./firebaseInit";
import { requestPermission } from "./firebaseInit";
import { fetchtoken } from "./firebaseInit";
import { Token } from "./firebaseInit";
import { onMessageListener } from "./firebaseInit";
import toast, { Toaster } from "react-hot-toast";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
// Import scss
import "./assets/scss/theme.scss"

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import fackbackend Configuration file
import fakeBackend from "./helpers/AuthType/fakeBackend"


// Activating fake backend
fakeBackend()

// Activating fake firebase
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTokenFound: false,
      show: false,
      notification: { title: "", body: "" },
    };
    this.getLayout = this.getLayout.bind(this)
  }


  showToast(message, title) {
    var positionClass = "toast-top-center";
    // var closeButton = true;
    // var newestOnTop= true;
    var preventDuplicates = true;

    toastr.options = {
      positionClass: positionClass,
      // closeButton: closeButton,
      preventDuplicates: preventDuplicates,
      // newestOnTop: newestOnTop,
    };
    toastr.info(message, title);
  }
  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  

  render() {
    const Layout = this.getLayout()
    onMessageListener()
      .then(payload => {
        this.setState({ show: true });
        this.setState({
          notification: {
            title: payload.notification.title,
            body: payload.notification.body,
          },
        });
        console.log("forground notif", payload);
      })
      .catch(err => console.log("failed: ", err));

    return (
      <React.Fragment>
         {this.state.show === true
          ? this.showToast(
              this.state.notification.body,
              this.state.notification.title
            )
          : console.log("false")}
          <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            // Define default options
            className: "",
            duration: 5000,
            style: {
              background: "#363636",
              color: "#fff",
            },

            // Default options for specific types
            success: {
              duration: 3000,
              theme: {
                primary: "green",
                secondary: "black",
              },
            },
          }}
        />
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact
              />
            ))}
          </Switch>
        </Router>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

App.propTypes = {
  layout: PropTypes.object,
}

export default connect(mapStateToProps, null)(App)
